const currentOpenDropdownMenu = useState<string | null>('global-dropdown-menu-state', () => null);

export function useGlobalDropdownMenu () {
    const unregisterDropdownMenu = (dropdownId: string): void => {
        // If this was the active dropdown, clear the state
        if (currentOpenDropdownMenu.value === dropdownId) {
            currentOpenDropdownMenu.value = null;
        }
    };

    const setActiveDropdownMenu = (dropdownId: string): void => {
        currentOpenDropdownMenu.value = dropdownId;
    };

    const closeActiveDropdownMenu = (): void => {
        currentOpenDropdownMenu.value = null;
    };

    const getActiveDropdownMenu = (): string | null => {
        return currentOpenDropdownMenu.value;
    };
    
    return {
        currentOpenDropdown: currentOpenDropdownMenu,
        unregisterDropdownMenu,
        setActiveDropdownMenu,
        closeActiveDropdownMenu,
        getActiveDropdownMenu
    };
}
